import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "text-center"
}
const _hoisted_3 = { class: "navbar fixed-bottom navbar-dark bg-dark" }
const _hoisted_4 = { class: "container d-flex justify-content-center" }
const _hoisted_5 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_6 = { class: "btn btn-secondary" }
const _hoisted_7 = { class: "text-lowercase d-none d-sm-inline" }
const _hoisted_8 = { class: "btn btn-secondary" }
const _hoisted_9 = { class: "text-lowercase d-none d-sm-inline" }
const _hoisted_10 = { class: "navbar navbar-expand-md navbar-dark bg-dark fixed-top" }
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "btn btn-light mr-auto" }
const _hoisted_13 = {
  class: "progress mx-2 w-50",
  style: {"height":"38px","background-color":"#D3D3D3"}
}
const _hoisted_14 = { style: {"padding-top":"80px","padding-bottom":"120px"} }
const _hoisted_15 = {
  id: "top",
  class: "mt-4"
}
const _hoisted_16 = { class: "font-weight-light" }
const _hoisted_17 = { class: "text-lowercase" }
const _hoisted_18 = { class: "navbar navbar-expand-md navbar-light bg-light" }
const _hoisted_19 = { class: "navbar-nav" }
const _hoisted_20 = { class: "nav-item dropdown" }
const _hoisted_21 = {
  class: "nav-link dropdown-toggle",
  id: "navbarDropdown",
  role: "button",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_22 = { class: "dropdown-menu" }
const _hoisted_23 = { class: "badge badge-secondary" }
const _hoisted_24 = { class: "badge badge-secondary" }
const _hoisted_25 = { class: "badge badge-secondary" }
const _hoisted_26 = { class: "badge badge-secondary" }
const _hoisted_27 = { class: "badge badge-secondary" }
const _hoisted_28 = { class: "form-inline my-2 my-lg-0 ml-auto" }
const _hoisted_29 = { class: "mt-5 mb-3 lead" }
const _hoisted_30 = { class: "text-lowercase" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-md-6" }
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "text-muted" }
const _hoisted_36 = {
  key: 0,
  class: "text-muted font-italic"
}
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "mt-5 mb-3 lead" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "text-lowercase" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-md-6" }
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "text-muted" }
const _hoisted_47 = {
  key: 0,
  class: "text-muted font-italic"
}
const _hoisted_48 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CriterionDetailsDialog = _resolveComponent("CriterionDetailsDialog")!
  const _component_AlternativeDetailsDialog = _resolveComponent("AlternativeDetailsDialog")!
  const _component_PanelistSurveyVoteEditorDr = _resolveComponent("PanelistSurveyVoteEditorDr")!
  const _component_PanelistSurveyVoteEditorPc = _resolveComponent("PanelistSurveyVoteEditorPc")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CriterionDetailsDialog, { viewModel: _ctx.criterionDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_AlternativeDetailsDialog, { viewModel: _ctx.alternativeDetailsDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.initialized === false)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [...(_cache[11] || (_cache[11] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading...", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.initialized === true)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("nav", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, [
                    _cache[12] || (_cache[12] = _createElementVNode("i", {
                      class: "fa fa-angle-double-left",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */)),
                    _cache[13] || (_cache[13] = _createTextVNode(" Prev ", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.alternativeLabel), 1 /* TEXT */)
                  ])), [
                    [_directive_sanitizedHref, `/#/scoring/alternative/${_ctx.workspaceId}/${_ctx.surveyId}/${_ctx.projectUserId}/${_ctx.prevAlternativeId}`]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-warning",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollTop && _ctx.scrollTop(...args)))
                  }, " Back to Top "),
                  _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_8, [
                    _cache[14] || (_cache[14] = _createTextVNode(" Next ", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.alternativeLabel), 1 /* TEXT */),
                    _cache[15] || (_cache[15] = _createElementVNode("i", {
                      class: "fa fa-angle-double-right",
                      "aria-hidden": "true"
                    }, null, -1 /* CACHED */))
                  ])), [
                    [_directive_sanitizedHref, `/#/scoring/alternative/${_ctx.workspaceId}/${_ctx.surveyId}/${_ctx.projectUserId}/${_ctx.nextAlternativeId}`]
                  ])
                ])
              ])
            ]),
            _createElementVNode("nav", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_12, [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("i", {
                    class: "fa fa-angle-double-left",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" My Survey ", -1 /* CACHED */)
                ]))])), [
                  [_directive_sanitizedHref, `/#/scoring/dashboard/${_ctx.workspaceId}/${_ctx.surveyId}/${_ctx.projectUserId}`]
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", {
                    class: "progress-bar",
                    role: "progressbar",
                    style: _normalizeStyle({'width': _ctx.progress + '%'})
                  }, _toDisplayString(_ctx.AnsweredQuestionsCount) + " / " + _toDisplayString(_ctx.questionsCount), 5 /* TEXT, STYLE */)
                ]),
                (_ctx.IsSaved == null)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-warning",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSavePanelistVotesCommand && _ctx.handleSavePanelistVotesCommand(...args)))
                    }, [...(_cache[17] || (_cache[17] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Saving... ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (_ctx.IsSaved === true)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-light",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSavePanelistVotesCommand && _ctx.handleSavePanelistVotesCommand(...args)))
                    }, " Saved "))
                  : _createCommentVNode("v-if", true),
                (_ctx.IsSaved === false)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "btn btn-warning",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSavePanelistVotesCommand && _ctx.handleSavePanelistVotesCommand(...args)))
                    }, " Save "))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h3", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, [
                  _cache[18] || (_cache[18] = _createTextVNode("Evaluate ", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.alternativeLabel), 1 /* TEXT */),
                  _cache[19] || (_cache[19] = _createTextVNode(": ", -1 /* CACHED */))
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.alternativeName), 1 /* TEXT */)
              ]),
              _cache[38] || (_cache[38] = _createElementVNode("hr", null, null, -1 /* CACHED */)),
              _createElementVNode("nav", _hoisted_18, [
                _createElementVNode("ul", _hoisted_19, [
                  _createElementVNode("li", _hoisted_20, [
                    _createElementVNode("a", _hoisted_21, " Questions: " + _toDisplayString(_ctx.QuestionsFilter ?? 'All'), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.QuestionsFilter = null))
                      }, [
                        _cache[20] || (_cache[20] = _createTextVNode("All ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.questionsCount), 1 /* TEXT */)
                      ]),
                      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.QuestionsFilter = 'Answered'))
                      }, [
                        _cache[21] || (_cache[21] = _createTextVNode("Answered ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.AnsweredQuestionsCount), 1 /* TEXT */)
                      ]),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.QuestionsFilter = 'Not answered'))
                      }, [
                        _cache[22] || (_cache[22] = _createTextVNode("Not answered ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.NotAnsweredQuestionsCount), 1 /* TEXT */)
                      ]),
                      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.QuestionsFilter = 'Commented'))
                      }, [
                        _cache[23] || (_cache[23] = _createTextVNode("Commented ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.CommentedQuestionsCount), 1 /* TEXT */)
                      ]),
                      _createElementVNode("a", {
                        class: "dropdown-item",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.QuestionsFilter = 'Not commented'))
                      }, [
                        _cache[24] || (_cache[24] = _createTextVNode("Not commented ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.NotCommentedQuestionsCount), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("form", _hoisted_28, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control mr-sm-2",
                    type: "search",
                    placeholder: "Filter criteria",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.SearchPhrase) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.SearchPhrase]
                  ])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DirectRatesView, (dr) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: dr.Id
                }, [
                  _createElementVNode("p", _hoisted_29, [
                    _createElementVNode("strong", null, _toDisplayString(dr.OrderValue) + ".", 1 /* TEXT */),
                    _cache[27] || (_cache[27] = _createTextVNode(" How would you rate ", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.alternativeLabel), 1 /* TEXT */),
                    _createElementVNode("a", {
                      class: "text-dark font-italic",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.ShowAlternativeDetailsCommand(_ctx.alternativeName, _ctx.alternativeDescription)))
                    }, _toDisplayString(_ctx.alternativeName), 1 /* TEXT */),
                    _cache[28] || (_cache[28] = _createTextVNode(" in the context of ", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: ($event: any) => (_ctx.ShowCriterionDetailsCommand(dr))
                    }, _toDisplayString(dr.CriterionName), 9 /* TEXT, PROPS */, _hoisted_31),
                    _cache[29] || (_cache[29] = _createTextVNode("? ", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_PanelistSurveyVoteEditorDr, {
                        propValue: dr.Value,
                        propComment: dr.Comment,
                        propScaleLevels: dr.ScaleLevels,
                        onUpdateValue: ($event: any) => (_ctx.updateValue(dr, $event)),
                        onUpdateComment: ($event: any) => (_ctx.updateComment(dr, $event))
                      }, null, 8 /* PROPS */, ["propValue", "propComment", "propScaleLevels", "onUpdateValue", "onUpdateComment"])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _cache[30] || (_cache[30] = _createElementVNode("h5", null, "Criterion description", -1 /* CACHED */)),
                      _createElementVNode("p", _hoisted_35, _toDisplayString(dr.CriterionPath), 1 /* TEXT */),
                      (!dr.CriterionDescription)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_36, "No description provided"))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("p", {
                        innerHTML: dr.CriterionDescription
                      }, null, 8 /* PROPS */, _hoisted_37)
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PairwiseComparisonsView, (pc) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: pc.Id
                }, [
                  _createElementVNode("p", _hoisted_38, [
                    _createElementVNode("strong", null, _toDisplayString(pc.OrderValue) + ".", 1 /* TEXT */),
                    _cache[31] || (_cache[31] = _createTextVNode(" In the context of ", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: ($event: any) => (_ctx.ShowCriterionDetailsCommand(pc))
                    }, _toDisplayString(pc.CriterionName), 9 /* TEXT, PROPS */, _hoisted_39),
                    _cache[32] || (_cache[32] = _createTextVNode(", which ", -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.alternativeLabel), 1 /* TEXT */),
                    _cache[33] || (_cache[33] = _createTextVNode(" do you prefer: ", -1 /* CACHED */)),
                    _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "text-dark font-italic",
                      onClick: ($event: any) => (_ctx.ShowAlternativeDetailsCommand(pc.FirstAlternativeName, pc.FirstAlternativeDescription))
                    }, _toDisplayString(pc.FirstAlternativeName), 9 /* TEXT, PROPS */, _hoisted_41),
                    _cache[35] || (_cache[35] = _createTextVNode(" or ", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "text-primary",
                      onClick: ($event: any) => (_ctx.ShowAlternativeDetailsCommand(pc.SecondAlternativeName, pc.SecondAlternativeDescription))
                    }, _toDisplayString(pc.SecondAlternativeName), 9 /* TEXT, PROPS */, _hoisted_42),
                    _cache[36] || (_cache[36] = _createTextVNode("? ", -1 /* CACHED */))
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_component_PanelistSurveyVoteEditorPc, {
                        propValue: pc.Value,
                        propComment: pc.Comment,
                        propFirstAlternativeName: pc.FirstAlternativeName,
                        propSecondAlternativeName: pc.SecondAlternativeName,
                        onUpdateValue: ($event: any) => (_ctx.updateValue(pc, $event)),
                        onUpdateComment: ($event: any) => (_ctx.updateComment(pc, $event))
                      }, null, 8 /* PROPS */, ["propValue", "propComment", "propFirstAlternativeName", "propSecondAlternativeName", "onUpdateValue", "onUpdateComment"])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      _cache[37] || (_cache[37] = _createElementVNode("h5", null, "Criterion description", -1 /* CACHED */)),
                      _createElementVNode("p", _hoisted_46, _toDisplayString(pc.CriterionPath), 1 /* TEXT */),
                      (!pc.CriterionDescription)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_47, "No description provided"))
                        : _createCommentVNode("v-if", true),
                      _createElementVNode("p", {
                        innerHTML: pc.CriterionDescription
                      }, null, 8 /* PROPS */, _hoisted_48)
                    ])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}